import {SiteBasics} from 'Common/SiteBasics';
import Assert from 'Common/Assert';
import {ArtistRoutes} from 'Common/artists/ArtistRoutes';
import {AdminRoutes} from 'Shared/admin/AdminRoutes';
import {VenueSettingsFactory} from 'Shared/VenueSettingsFactory';
import {SiteType} from 'Common/SiteType';
import { BrowserId } from 'Browser/BrowserId';


export function selectRoutes(site:SiteBasics<BrowserId>)
{
	switch(site.type) {
		case SiteType.venue:	
			const settings = (new VenueSettingsFactory()).createSettings(site.key);
			const routerClass = settings.routes();
			return (new routerClass(settings.pages())).routes();

		case SiteType.artist:
			return (new ArtistRoutes()).routes();

		case SiteType.admin:
			return (new AdminRoutes()).routes();
	}
console.log('RoutesSelector site.type:',site.type);	
	Assert.check(false);
}

